import { DefaultReferralProspectFormState, IReferralProspectFormState } from 'models/referralprospect';

export interface IState {
	form: IReferralProspectFormState;
}

export const initialState: IState = {
	form: DefaultReferralProspectFormState
};
